import { Section, GridContainer } from '../layout';
import { AnimatedSection, ResponsiveWidgetWrapper } from '../shared';
import { PillarLabel } from '../ui';
import { TemplateEditorWidget } from '../widgets/TemplateEditorWidget';
import { ContractsTableWidget } from '../widgets/ContractsTableWidget';
import { NotificationsWidget } from '../widgets/NotificationsWidget';

/**
 * Pillar 2: Automatiza - Contract automation features.
 * Includes SignatureProgress and NotificationsWidget.
 */
export function PillarAutomatiza() {
  return (
    <Section size="md" className="relative z-10">
      <AnimatedSection>
        <GridContainer>
          {/* Pillar Label */}
          <div className="col-span-4 md:col-span-8 xl:col-span-12">
            <PillarLabel number="02" label="Automatiza" />
          </div>

          {/* Header */}
          <div className="col-span-4 md:col-span-8 xl:col-span-12 mt-4 flex flex-col items-center">
            <h2 className="text-[28px] md:text-3xl xl:text-4xl font-semibold text-text-primary tracking-tight text-center max-w-[450px]">
              Contratos que se generan y firman solos.
            </h2>
            <p className="text-body text-text-secondary mt-4 text-center text-balance max-w-[600px] px-6 md:px-0">
              Crea tus plantillas con nuestro editor inteligente. Variables dinámicas para cada
              inversión. Genera contratos automáticamente y envía a firma digital.
            </p>
          </div>

          {/* Template Editor Widget */}
          <div className="col-span-4 md:col-span-8 xl:col-span-10 xl:col-start-2 mt-8">
            <ResponsiveWidgetWrapper designWidth={720} designHeight={480}>
              <TemplateEditorWidget autoPlay />
            </ResponsiveWidgetWrapper>
          </div>
        </GridContainer>

        {/* Two-Column Feature Grid */}
        <GridContainer className="mt-16">
          {/* Left: Signature Progress (columns 1-6) */}
          <div className="col-span-4 md:col-span-4 xl:col-span-6 flex flex-col">
            <h3 className="text-h3 text-text-tertiary mb-2 text-center md:text-left">
              Sabe quién ha firmado y quién falta
            </h3>
            <p className="text-body-small text-text-secondary mb-4 md:mb-8 max-w-[380px] text-center md:text-left px-6 md:px-0 mx-auto md:mx-0">
              Seguimiento en tiempo real del estado de cada contrato. Visualiza de un vistazo qué
              firmas están pendientes.
            </p>
            <div
              style={{
                maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
              }}
            >
              <ResponsiveWidgetWrapper designWidth={504} designHeight={280}>
                <ContractsTableWidget autoPlay />
              </ResponsiveWidgetWrapper>
            </div>
          </div>

          {/* Right: Notifications (columns 7-12, text starts at column 8) */}
          <div className="col-span-4 md:col-span-4 xl:col-span-6 flex flex-col mt-20 md:mt-0">
            <div className="xl:pl-[calc(100%/6)]">
              <h3 className="text-h3 text-text-tertiary mb-2 text-center md:text-left">
                Eventos que disparan acciones
              </h3>
              <p className="text-body-small text-text-secondary mb-8 max-w-[380px] text-center md:text-left px-6 md:px-0 mx-auto md:mx-0">
                Notificaciones automáticas cuando se firma un contrato, se recibe un pago o vence un
                plazo. Nunca pierdas el hilo.
              </p>
            </div>
            <div
              style={{
                maskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
                WebkitMaskImage: 'linear-gradient(to bottom, black 70%, transparent 100%)',
              }}
            >
              <NotificationsWidget />
            </div>
          </div>
        </GridContainer>
      </AnimatedSection>
    </Section>
  );
}
